import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "w-100 verify-card" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "pb-3" }
const _hoisted_5 = { class: "fw-bold d-flex align-items-center text-dark ms-3" }
const _hoisted_6 = {
  class: "fv-row mb-10 ms-3",
  style: {"font-size":"16px"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-9 mb-9" }, null, -1)
const _hoisted_8 = { class: "questionTitle mb-7" }
const _hoisted_9 = { class: "form-check form-check-custom form-check-solid mx-5" }

import { onMounted, ref, watch } from "vue";
import { Field } from "vee-validate";
import questionDB from "@/core/data/verification/auQuizQuestions";
import clientAns from "@/core/data/verification/auQuizAnswers";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserQuizs',
  props: {
    verificationDetails: {}
  },
  setup(__props: any) {

const props = __props;

const questions = ref<any>(questionDB["en-us"]);
const score = ref(0);
const total = ref(0);
const isLoading = ref(true);


const quiz = ref<any>({
  ...props.verificationDetails?.quiz,
});

onMounted(() => {
  isLoading.value = true;

  total.value = Object.keys(quiz.value).length - 1;
  score.value = Object.keys(quiz.value).length - 1;

  delete quiz.value[10];

  for (const index in quiz.value) {
    if (quiz.value[index].answer != clientAns[quiz.value[index].id].answer) {
      score.value -= 1;
    }
  }

  isLoading.value = false;
});

watch(
  () => props.verificationDetails,
  () => {
    quiz.value = {
      ...props.verificationDetails?.quiz,
    };
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t("title.quiz")) + " ( Score: " + _toDisplayString(score.value) + "/" + _toDisplayString(total.value) + " ) ", 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(quiz.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, _toDisplayString(questions.value[item.id].question), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questions.value[item.id].options, (option, val, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "d-flex mt-3",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_unref(Field), {
                        modelValue: item.answer,
                        "onUpdate:modelValue": ($event: any) => ((item.answer) = $event),
                        class: "form-check-input",
                        type: "radio",
                        name: item.id.toString(),
                        value: val
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "value"])
                    ]),
                    _createElementVNode("div", null, _toDisplayString(option), 1)
                  ]))
                }), 128))
              ]))
            }), 128))
          ])
        ]))
  ]))
}
}

})